$(document).ready(function () {
  // $('.slideitems').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     arrows: false,
  //     dots: true,
  //     speed: 400,
  // });
})